import * as yup from 'yup';
import {
  BillingPlan,
  ProductAccountTypes,
  ProductTypes,
} from '@src/types/productsAddons.ts';
import { validZipCode } from '@lib/onboarding.ts';
import { ZipRange } from '@src/services/dropdown.ts';
import { ReactNode } from 'react';

export type TAddons = {
  display_name_app?: string;
  display_name_web?: string;
  id: number;
  price: number;
  title: string;
  icon?: ReactNode;
};

export type TPackages = Partial<{
  id: number;
  billing_plan: BillingPlan;
  addons: TAddons[];
  account_type: string;
  type: ProductAccountTypes;
  category: ProductTypes;
  account_benefits: string;
  is_visible_on_web: boolean;
  is_bundle: boolean;
  title: string;
  display_name_web: string;
  display_name_app: string;
}>;

export const paymentFormSchema = yup.object({
  street: yup.string().required('Street is required'),
  city: yup.string().required('City is required'),
  country: yup.string().required('Country is required'),
  state: yup.string().when('country', {
    is: (val: string) => val === 'US',
    then: (schema) => schema.required('State is required'),
    otherwise: (schema) => schema.optional(),
  }),
  zip_code: yup
    .string()
    .when('country', {
      is: (val: string) => val === 'US',
      then: (schema) => schema.required('Zip code is required'),
      otherwise: (schema) => schema.optional(),
    })
    .test(
      'zip-valid',
      'Zip code is not eligible for the selected country',
      function (value) {
        const { zip_range, country } = this.parent;

        if (country !== 'US') return true;
        if (!value || !Array.isArray(zip_range)) return true;

        return validZipCode(value, zip_range as ZipRange[]);
      }
    ),
  phone_number: yup.string().required('Phone number is required'),
  first_name: yup.string().required('First name is required'),
  last_name: yup.string().required('Last name is required'),
  coupon_code: yup.string(),
  referral_source: yup.string(),
  zip_range: yup.array(),
  payment_type: yup
    .string()
    .required('Please select a payment service provider'),
});

export type PaymentFormValues = yup.InferType<typeof paymentFormSchema>;
